import React, {useState, useMemo, useEffect} from 'react';
import PropTypes from 'prop-types';

import {CSSTransition} from 'react-transition-group';
import {classNames} from '~/src/utilities/helpers/css';
import {SlideTransition} from '~/src/utilities/constants/transitions';

import css from './SlideshowSlide.module.scss';

const addEndListener = (node, done) => {
    node.addEventListener('transitionend', done, false);
};

const SlideshowSlide = ({direction = SlideTransition.SLIDE_LEFT, active = false, children, format}) => {
    const [slideEnterDone, setSlideEnterDone] = useState(active);
    const transitionClasses = useMemo(
        () => ({
            enter: direction === SlideTransition.SLIDE_LEFT ? css.slideEnterLeft : css.slideEnterRight,
            enterActive: css.slideEnterActive,
            enterDone: css.slideEnterDone,
            exit: css.slideExit,
            exitActive: direction === SlideTransition.SLIDE_RIGHT ? css.slideExitActiveLeft : css.slideExitActiveRight,
            exitDone: css.slideExitDone
        }),
        [active]
    );

    const classes = useMemo(() => classNames(css, 'slide', format, {slideEnterDone}), [active]);

    useEffect(() => {
        setSlideEnterDone(false);
    }, []);

    return (
        <CSSTransition in={active} classNames={transitionClasses} addEndListener={addEndListener}>
            <div className={classes}>{children}</div>
        </CSSTransition>
    );
};

if (process.env.NODE_ENV === 'development') {
    SlideshowSlide.propTypes = {
        direction: PropTypes.oneOf([SlideTransition.SLIDE_LEFT, SlideTransition.SLIDE_RIGHT]),
        active: PropTypes.bool,
        children: PropTypes.node.isRequired,
        format: PropTypes.string
    };
}

export default SlideshowSlide;
